const CACHE_VERSION = 'driessenstoffen-redux-cache-001';

export const getValuesFromCache = () => {
  try {
    const cachedData = sessionStorage.getItem(CACHE_VERSION);
    if (cachedData) {
      const parsedCachedData = JSON.parse(cachedData);
      return Array.isArray(parsedCachedData) ? parsedCachedData : [];
    }
    return [];
  } catch {
    return [];
  }
};

export const getValueFromCache = (endpoint: string, params: object) => getValuesFromCache()
  .find((cachedItem) => (cachedItem.endpoint === endpoint
    && JSON.stringify(cachedItem.params) === JSON.stringify(params)));

export const addValueToCache = (endpoint: string, params: object, data: any) => {
  const cache = getValuesFromCache();
  const existingIndex = cache.findIndex((item) => item.endpoint === endpoint
    && JSON.stringify(item.params) === JSON.stringify(params));
  if (existingIndex !== -1) {
    cache[existingIndex] = { endpoint, params, data };
  } else {
    cache.push({ endpoint, params, data });
  }
  try {
    sessionStorage.setItem(CACHE_VERSION, JSON.stringify(cache));
  } catch {
    // Silently fail if storage is not available
  }
};
